var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptimized(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 43,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 9165,
    transform: "translate(-185 -2035)",
    fill: "#180045"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 1",
    filter: "url(#filter0_b_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -186,
    y: -1957,
    width: 1920,
    height: 9087,
    fill: "#180045",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "features",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M27.5 20L24 28V29L25 32.5L27.5 34H32.5L44.5 33.5C48.9 31.9 47 25.5 45.5 22.5L44.5 20L42 17.5L39 15.5L41 12.5L41.5 8L41 5.5L38.5 3.5L34 3L30.5 5L30 10C32.8 14.4 32.1667 16.1667 31.5 16.5L27.5 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.38994 22.3097C8.58994 19.3097 4.38991 12.3097 11.4599 8.30972C15.2899 6.13972 20.4599 9.16972 21.3899 13.3097C22.4499 18.3097 20.3899 22.3097 17.3899 23.3097C28.9599 28.3097 29.4499 38.3097 28.3899 40.3097C27.3299 42.3097 24.5499 42.3097 24.0599 42.3097C17.8399 42.4497 14.9299 42.3097 8.39992 42.0797C5.05992 41.9797 2.39992 40.3797 2.39992 37.2197C2.38992 26.7497 8.06994 27.0897 8.38994 22.3097Z",
    fill: "#F38360"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.0499 22.4899C45.9999 18.3399 42.5699 15.8999 38.6599 14.6799L38.9499 16.8699C42.7899 14.6699 44.3899 8.66988 41.8399 5.01988C40.9569 3.72988 39.7069 2.73373 38.2529 2.15985C36.7989 1.58597 35.2059 1.4606 33.6799 1.79987C32.5199 1.97289 31.4409 2.49836 30.5889 3.30508C29.7379 4.11188 29.1549 5.16078 28.9199 6.30988C28.0199 10.2099 29.6699 13.6999 32.0399 16.7099L32.2799 14.8199C28.8699 16.9999 25.8199 19.4699 24.7299 23.5399C24.6449 23.8476 24.6859 24.1763 24.8429 24.4539C25.0009 24.7314 25.2619 24.935 25.5699 25.0199C25.8769 25.1048 26.2059 25.064 26.4839 24.9064C26.7609 24.7489 26.9649 24.4876 27.0499 24.1799C27.9699 20.7299 30.6199 18.7299 33.4999 16.8999C33.6539 16.8033 33.7859 16.6734 33.8839 16.5199C33.9819 16.3663 34.0449 16.1927 34.0679 16.0118C34.0909 15.8309 34.0739 15.6472 34.0169 15.4739C33.9599 15.3006 33.8649 15.1421 33.7399 15.0099C31.8299 12.5899 30.2899 9.40988 31.4199 6.28988C32.2199 4.09988 35.3099 3.56988 37.2899 4.28988C37.9899 4.57378 38.6259 4.99658 39.1589 5.53278C39.6919 6.06898 40.1099 6.70758 40.3899 7.40988C40.8259 8.82588 40.7409 10.3513 40.1499 11.7099C39.7879 12.6284 39.2359 13.4599 38.5299 14.1499C38.2939 14.4139 38.0129 14.6339 37.6999 14.7999C37.5009 14.9224 37.3419 15.0999 37.2419 15.3109C37.1409 15.5219 37.1039 15.7574 37.1349 15.9889C37.1659 16.2205 37.2629 16.4382 37.4139 16.6158C37.5659 16.7934 37.7659 16.9234 37.9899 16.9899C41.1199 17.9899 43.8599 19.7999 44.6999 23.1299C44.7419 23.2822 44.8129 23.4248 44.9109 23.5495C45.0079 23.6741 45.1279 23.7784 45.2659 23.8564C45.4029 23.9344 45.5549 23.9846 45.7119 24.0041C45.8679 24.0235 46.0269 24.0119 46.1799 23.9699C46.3319 23.9279 46.4749 23.8563 46.5989 23.7592C46.7239 23.662 46.8279 23.5413 46.9059 23.4039C46.9839 23.2665 47.0339 23.115 47.0539 22.9582C47.0729 22.8014 47.0619 22.6422 47.0199 22.4899H47.0499Z",
    fill: "#1E2882"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M46.1499 28.9395C46.2799 29.6389 46.1579 30.3617 45.8039 30.979C45.4509 31.5962 44.8889 32.0678 44.2199 32.3095C42.9739 32.6482 41.6799 32.7832 40.3899 32.7095C37.8299 32.7095 35.2499 32.7095 32.6799 32.6095C31.1399 32.5495 31.1399 34.9495 32.6799 35.0095C35.5799 35.1195 38.4999 35.1695 41.3999 35.0895C43.1999 35.1907 44.9869 34.737 46.5199 33.7895C47.3349 33.154 47.9539 32.3022 48.3079 31.3315C48.6619 30.3607 48.7349 29.3101 48.5199 28.2995C48.4359 27.9936 48.2339 27.7335 47.9589 27.5761C47.6829 27.4187 47.3569 27.3768 47.0499 27.4595C46.7469 27.5504 46.4899 27.7551 46.3329 28.0308C46.1769 28.3066 46.1329 28.6321 46.2099 28.9395H46.1499Z",
    fill: "#1E2882"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.20004 13.6295H3.61001C3.92701 13.6221 4.23001 13.4974 4.46001 13.2795C4.57201 13.1681 4.66002 13.0356 4.72002 12.8897C4.78102 12.7437 4.81102 12.5873 4.81002 12.4295C4.81202 12.2715 4.78201 12.1148 4.72201 11.9687C4.66201 11.8226 4.57301 11.6902 4.46001 11.5795C4.23401 11.3556 3.92801 11.2298 3.61001 11.2295H1.20004C0.882036 11.2298 0.57603 11.3556 0.35003 11.5795C0.23803 11.6909 0.15002 11.8234 0.0900198 11.9693C0.0300198 12.1153 -0.000976548 12.2717 2.34516e-05 12.4295C2.34516e-05 12.5953 0.0350132 12.7592 0.102013 12.9107C0.169013 13.0622 0.267038 13.1981 0.390038 13.3095C0.619038 13.529 0.923014 13.654 1.24001 13.6595L1.20004 13.6295Z",
    fill: "#1E2882"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.66985 1.7901L9.17983 4.51008C9.33783 4.77698 9.59185 4.97368 9.88985 5.06008C10.2038 5.14118 10.5368 5.09828 10.8198 4.94008C11.0848 4.77428 11.2778 4.51328 11.3578 4.21028C11.4378 3.90738 11.3988 3.58548 11.2498 3.31008L9.73982 0.5901C9.58182 0.32315 9.32783 0.12648 9.02983 0.0401001C8.71583 -0.0410399 8.38284 0.00194001 8.09984 0.1601C7.82884 0.32626 7.63283 0.59089 7.55183 0.8985C7.47183 1.2061 7.51385 1.5328 7.66985 1.8101V1.7901Z",
    fill: "#1E2882"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.3899 6.56959L24.0199 4.13959C24.1009 4.00039 24.1529 3.84639 24.1739 3.68669C24.1939 3.52699 24.1829 3.36479 24.1399 3.20959C24.0539 2.91164 23.8569 2.65776 23.5899 2.49963C23.4509 2.41876 23.2969 2.36649 23.1369 2.34588C22.9769 2.32528 22.8149 2.33675 22.6599 2.37963C22.3669 2.4751 22.1159 2.66952 21.9499 2.92963L20.3199 5.35959C20.2389 5.49889 20.1869 5.65279 20.1659 5.81249C20.1459 5.97219 20.1569 6.13439 20.1999 6.28959C20.2819 6.59229 20.4799 6.85069 20.7499 7.00959C21.0289 7.16819 21.3589 7.21129 21.6699 7.12959C21.9699 7.03689 22.2259 6.83769 22.3899 6.56959Z",
    fill: "#1E2882"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_1",
    x: -336,
    y: -2107,
    width: 2220,
    height: 9387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 9165,
    fill: "white",
    transform: "translate(-185 -2035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1055,
    fill: "white",
    transform: "translate(-185 -568)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimized);
export default __webpack_public_path__ + "static/media/optimized.eae7c2c91c533bd90d8fcab0b46e16cc.svg";
export { ForwardRef as ReactComponent };